export const buildActiveFeatureArr = (savingsInfo, investments, creditCardInfo, 
        timeWizardInfo, funStuffInfo) => {
    let activeFeatureObj = {};
    let activeFeatureArr = [];
    
    if (investments.length > 0){
        const checkInvestArr = investments.filter(elem => elem.currentlyActive === true);
        if (checkInvestArr.length > 0){
            activeFeatureObj = {featureName: "moneyBuilder", level: 3};
            activeFeatureArr.push(activeFeatureObj);
        }
    }else{
        if (savingsInfo.gameID  &&
            savingsInfo.currentlyActive === true){
                activeFeatureObj = {featureName: "moneyBuilder", level: savingsInfo.level};
                activeFeatureArr.push(activeFeatureObj);
        }
    }
    if (creditCardInfo.gameID  &&
        creditCardInfo.currentlyActive === true){
            activeFeatureObj = {featureName: "creditCard", level: creditCardInfo.cardLevel}
            activeFeatureArr.push(activeFeatureObj);
    }
    if (timeWizardInfo.gameID  &&
        timeWizardInfo.status !== "inactive"){
            activeFeatureObj = {featureName: "timeWizard", level: timeWizardInfo.level}
            activeFeatureArr.push(activeFeatureObj);
    }
    if (funStuffInfo.itemArr &&
        funStuffInfo.itemArr.length > 0){
        const funStuffArr = funStuffInfo.itemArr;
        let funStuffLevel = 0;
        for (let i=0; i<funStuffArr.length; i++){
            if (funStuffArr[i].levelNbr > funStuffLevel){
                funStuffLevel = funStuffArr[i].levelNbr;
            }
        }
        activeFeatureObj = {featureName: "funStuff", level: funStuffLevel};
        activeFeatureArr.push(activeFeatureObj);
    }
    return activeFeatureArr;
}
export default buildActiveFeatureArr;